export function sumVoice(rows) {
  const t = { ic: 0, id: 0, it: 0, oc: 0, od: 0, ot: 0 };
  for (const { metrics: m } of rows) {
    t.ic += m.inbound_calls || 0;
    t.id += (m.inbound_seconds || 0) / 60;
    t.it += m.inbound_billed_minutes || 0;
    t.oc += m.outbound_calls || 0;
    t.od += (m.outbound_seconds || 0) / 60;
    t.ot += m.outbound_billed_minutes || 0;
  }
  return [
    t.ic,
    t.id,
    t.it,
    t.oc,
    t.od,
    t.ot,
    t.ic + t.oc,
    t.id + t.od,
    t.it + t.ot,
  ];
}

export function breakdownOf(month) {
  return month.rows.length > 1 || month.rows.some((r) => r.segment)
    ? [...month.rows].sort(
        (a, b) =>
          a.organizationId.localeCompare(b.organizationId) ||
          a.segment.localeCompare(b.segment),
      )
    : [];
}

export const expandableMonths = (months) =>
  months.filter((m) => breakdownOf(m).length > 0).map((m) => m.month);

export function breakdownLabel(row, orgs) {
  const org = orgs.find((o) => o.organizationId === row.organizationId);
  const orgName = org?.label || `…${row.organizationId.slice(-6)}`;
  return [orgs.length > 1 || !row.segment ? orgName : null, row.segment]
    .filter(Boolean)
    .join(' · ');
}

const number = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
export const fmt = (value) => number.format(value || 0);

export function summaryCards(run, linkedClients) {
  if (!run) return null;
  const t = run.totals;
  const u = run.unmappedTotals;
  const orgs = run.unmapped.length;
  return [
    ['Clients with calls', fmt(run.clients), `of ${fmt(linkedClients)} linked`],
    ['Calls', fmt(t.calls), 'inbound + outbound'],
    ['Duration (min)', fmt(t.seconds / 60), 'exact call time'],
    ['Tarification (min)', fmt(t.billedMinutes), 'rounded up per call'],
    [
      'Not linked to a client',
      `${fmt(u.billedMinutes)} min`,
      `${fmt(u.calls)} calls · ${orgs} organization${orgs === 1 ? '' : 's'}`,
      u.calls > 0,
    ],
  ];
}

export const shortMonth = (month) =>
  new Date(`${month}-01T00:00:00Z`).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });

export function monthsSummary(monthsNewestFirst) {
  if (monthsNewestFirst.length <= 3)
    return monthsNewestFirst.map(shortMonth).join(', ');
  const shown = monthsNewestFirst.slice(0, 2).map(shortMonth).join(', ');
  return `${shown} +${monthsNewestFirst.length - 2}`;
}

export function monthlySeries(runs, monthsOldestFirst, valueOf) {
  const runByMonth = new Map(runs.map((r) => [r.month, r]));
  return monthsOldestFirst.map((month) => {
    const run = runByMonth.get(month);
    return {
      month,
      value: run ? valueOf(run) : null,
      complete: run ? run.complete : null,
    };
  });
}

export function niceCeiling(value) {
  if (value <= 0) return 1;
  const magnitude = 10 ** Math.floor(Math.log10(value));
  const step = [1, 2, 2.5, 5, 10].find((s) => s * magnitude >= value);
  return step * magnitude;
}

const trimmed = (value) => String(Number(value.toFixed(2)));

export function compactNumber(value) {
  if (value >= 1e6) return `${trimmed(value / 1e6)}M`;
  if (value >= 1e3) return `${trimmed(value / 1e3)}k`;
  return trimmed(value);
}
